<template>
<div></div>
</template>

<script>
import { createApp } from 'vue'
import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3'

const component = {
  setup() {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

    const recaptcha = async () => {
      // (optional) Wait until recaptcha has been loaded.
      await recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await executeRecaptcha('login')
      return token;      // Do stuff with the received token.
    }

    return {
      recaptcha
    }
  },
    template: '<button @click="recaptcha">Execute recaptcha</button>'
}
createApp(component)
  .use(VueReCaptcha, { siteKey: '6LdVL7YaAAAAADTVtM2CdVDqYergo8N96Vch-Vlv', loaderOptions: { autoHideBadge: true, explicitRenderParameters: {badge: 'bottomleft'} }, })
  
export default {
}
</script>

<style>

</style>